<template>
    <div class="main-content">
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客户</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客户详情</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">添加商机</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="detailContent circulation-all">
            <div class="circulation-view">
                <div class="circulation-menu">
                    <div >
                        <a v-for="(item,index) in menuList" :key="index" @click="addClass(index,item.url)" :class="index==current? 'ischeck':''">
                            <h3>{{item.title}}</h3>
                            <a-icon type="right" />
                        </a>
                    </div>
                </div>
                <div class="circulation-content">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <div id="circulation-customer">
                            <div class="circulation-head">
                                <h4>基础信息</h4>
                            </div>
                            <div class="circulation-info">

                                <div class="circulation-area">
                                    <a-form-item v-for="(item,i) in system_field_list" :key="i" :label="item.name"> 
                                       
                                       
                                        <a-input v-model="labelitem[item.field_name]" v-if="item.type=='text'||item.type=='mobile'||item.type=='email'" placeholder="请输入"/>
                                        <a-select v-model="labelitem[item.field_name]" v-if="item.type=='radio'" placeholder="请选择" style="width: 100%">
                                            <a-select-option :value="option" v-for="(option,idx) in item.option_arr" :key="idx">
                                                {{option}}
                                            </a-select-option>
                                        </a-select>
                                        <a-date-picker format="YYYY-MM-DD" placeholder="请选择" v-model="labelitem[item.field_name]"  v-if="item.type=='date'"/>
                                        <a-textarea v-model="labelitem[item.field_name]" v-if="item.type=='textarea'" placeholder="请输入" :auto-size="{ minRows: 2,maxRows:6}"/>
                                    </a-form-item>
                                </div>
                                
                            </div>
                        </div>
                        <div id="circulation-contacts">
                            <div class="circulation-head" >
                                <h4>联系人信息</h4>
                                <a-checkbox :checked="lxcheck" @change="onChangelx" >同步创建联系人</a-checkbox>
                            </div>
                            <div class="circulation-area" v-if="addlx">
                                <a-form-item label="联系人">
                                    <a-select placeholder="请选择" style="width: 100%" mode="multiple">
                                        <a-select-option :value="option.id" v-for="(option,idx) in contactlist" :key="idx" >
                                            {{option.contact_name}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>

                            </div>
                        </div>
                    </a-form>
                </div>
            </div>
        </div>

        <div class="add-button">
            <a-button icon="close-circle" theme="filled">取消</a-button>
            <a-button icon="check-circle" type="primary" @click="savetokh" theme="filled">保存</a-button>
        </div>
    </div>
</template>

<style>
.ischeck {
    background: #4f7afd !important;
    color: #fff !important;
}
.ischeck h3{color: #fff !important;}
</style>

<script>
export default {
    data(){
        return{
            current:0,
            menuList:[
                {title:'商机信息',url:'#circulation-customer'},
                {title:'联系人信息',url:'#circulation-contacts'}
            ],
            select:1,
            newsarea:true,
            oldarea:false,
            value: undefined,
            data:"",
            fieldlist:"",
            system_field_list:"",
            lxfieldlist:"",
            lxsystem_field_list:"",
            sjfieldlist:"",
            sjsystem_field_list:"",
            labelitem:{},
            labelname:{},
            lxlabelitem:{},
            lxlabelname:{},
            sjlabelitem:{},
            sjlabelname:{},
            addcontact:1,
            addbussness:1,
            addlx:true,
            addsj:true,
            lxcheck:true,
            sjcheck:true,

            contactlist:""

        }
        
    },
     mounted(){
        //  联系人
        this.$axios.get('/api/getcontactbykehuid',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                kehu_id:this.$route.query.id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.contactlist=res.data.data
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

         // 客户字段
        this.$axios.get('/api/bussnessfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
                for(var j in data2){
                    this.labelname[data2[j].field_name]=""
                    this.labelitem[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

         // 联系人字段
        this.$axios.get('/api/contactfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.lxsystem_field_list=data2
                for(var j in data2){
                    this.lxlabelname[data2[j].field_name]=""
                    this.lxlabelitem[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
            }else{
                this.$message.warning(res.data.msg);
            }
        })

    },
    methods:{
        onChangelx(e){
            var flag=e.target.checked
            if(flag){
                this.addcontact=1
                this.addlx=true
                this.lxcheck=true
            }else{
                this.addcontact=2
                this.addlx=false
                this.lxcheck=false
            }
        },

        onChangesj(e){
            var flag=e.target.checked
            if(flag){
                this.addbussness=1
                this.addsj=true
                this.sjcheck=true
            }else{
                this.addbussness=2
                this.addsj=false
                this.sjcheck=false
            }
        },
        // 转客户
        savetokh(){
            // var data2=this.system_field_list
            // for(var i in data2){
            //     this.labelname[data2[i].field_name]=this.labelitem[i]
            // }
            // var data3=this.lxsystem_field_list
            // for(var i in data3){
            //     this.lxlabelname[data3[i].field_name]=this.lxlabelitem[i]
            // }
            // var arr=new URLSearchParams()
            // arr.append('kh_arr',JSON.stringify(this.labelname))
            // arr.append('contact_arr',JSON.stringify(this.lxlabelname))
            // arr.append('addcontact',this.addcontact)
            this.$axios.post('/api/tobussness',{
                'bussness_arr':this.labelitem,
                // 'contact_arr':this.lxlabelitem,
                'kehu_id':this.$route.query.id,
                'addcontact':this.addcontact,
                'addbussness':this.addbussness
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.$router.push({path: '/custom'});
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 查询关联客户
        handleSearch(value) {
            this.fetch(value);
        },

        handleChange(value) {
            this.value = value;
        },
        fetch(value){
            this.$axios.get('/api/searchkehubyname',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },params:{
                    name:value
                }
            }).then((res)=>{
                if(res.data.code==40014){
                   this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.data=res.data.data
                   
                }else{
                    this.$message.error(res.data.msg);
                }
            }) 
        },

        onChangekh(){

        },
        addClass(index,event){
            // alert(index)
            this.current=index
                // 找到锚点
            let anchorElement = document.getElementById(event);
            // 如果对应id的锚点存在，就跳转到锚点
            if(anchorElement) { anchorElement.scrollIntoView(); }
        },
        onSelect(e) {
            this.select=e.target.value;
            if(e.target.value==1){
                this.newsarea=true,
                this.oldarea=false
            }else{
                this.newsarea=false,
                this.oldarea=true
            }
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/addkhsj.vue